import { FrameName } from "../config";
import AbstractSalvageableTileEntity from "./AbstractSalvageableTileEntity";

class CollapsedMineSalvageableTileEntity extends AbstractSalvageableTileEntity {
	public static readonly frameName = FrameName.COLLAPSED_MINE;
}

export default CollapsedMineSalvageableTileEntity;
